import Dashboard from '@src/main/ui/components/Dashboard/Dashboard';
import { type FC } from 'react';

const DashboardPage: FC = () => <Dashboard />;

export default DashboardPage;
